import { useSidebar } from '../../contexts/SidebarContext';
import { SidebarNavItem } from './SidebarNavItem';
import type { NavSection } from './sidebarConfig';

interface SidebarNavProps {
  sections: NavSection[];
}

export function SidebarNav({ sections }: SidebarNavProps) {
  const { isCollapsed } = useSidebar();

  return (
    <nav className="flex-1 overflow-y-auto py-4 px-3 sidebar-nav-scroll">
      {sections.map((section, index) => (
        <div key={section.id} className={index > 0 ? 'mt-6' : ''}>
          {/* Section title - hidden when collapsed */}
          {!isCollapsed && (
            <h3 className="px-3 mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
              {section.title}
            </h3>
          )}

          {/* Divider when collapsed */}
          {isCollapsed && index > 0 && (
            <div className="mx-2 mb-3 border-t border-slate-800" />
          )}

          {/* Navigation items */}
          <div className="space-y-1">
            {section.items.map((item) => (
              <SidebarNavItem key={item.id} item={item} />
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
}
